import React, { useState, useEffect } from "react";
import PivotTableUI from "react-pivottable/PivotTableUI";
import "react-pivottable/pivottable.css";
// import TableRenderers from "react-pivottable/TableRenderers";
import Plot from "react-plotly.js";
import createPlotlyRenderers from "react-pivottable/PlotlyRenderers";
import "./PivotTableWithECharts.scss";
import "bootstrap/dist/css/bootstrap.min.css";

const PlotlyRenderers = createPlotlyRenderers(Plot);

const PivotTableWithECharts = ({
  data,
  initialPivotState,
  onChartTypeChange,
  onChange,
  hidePivotUI,
}) => {
  const [pivotState, setPivotState] = useState(initialPivotState);
  useEffect(() => {
    const attrValues = {};
    data.forEach((record) => {
      Object.keys(record).forEach((key) => {
        if (!attrValues[key]) {
          attrValues[key] = new Set();
        }
        attrValues[key].add(record[key]);
      });
    });

    const attrValuesArray = {};
    Object.keys(attrValues).forEach((key) => {
      attrValuesArray[key] = Array.from(attrValues[key]);
    });
    setPivotState((prevState) => ({
      ...prevState,
      attrValues: attrValuesArray,
    }));
  }, [data]);

  const handleChange = (newState) => {
    setPivotState(newState);
    if (onChartTypeChange) {
      onChartTypeChange(newState.rendererName);
    }

    if (onChange) {
      onChange(
        newState.rendererName,
        newState.cols,
        newState.rows,
        newState.aggregatorName,
        newState.vals
      );
    }
  };
  const containerClass = `pivot-table-container ${
    hidePivotUI ? "hide-specific-elements" : ""
  }`;

  return (
    <div className={containerClass}>
      <PivotTableUI
        data={data}
        onChange={handleChange}
        renderers={Object.assign({}, PlotlyRenderers)}
        {...pivotState}
      />
    </div>
  );
};

export default PivotTableWithECharts;
